import styled from 'styled-components';
import { key } from 'styled-theme';

export const FormWrapper = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  margin-bottom: 18px;
`;

export const PasswordFieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Label = styled.label`
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  margin-bottom: 4px;
`;

export const PasswordInputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
`;

export const StyledInputField = styled.input`
  width: 100%;
  padding: 9px 36px 9px 12px;
  font-size: 13px;
  border: 1.5px solid #d1d5db;
  border-radius: 7px;
  background: #ffffff;
  color: #111827;
  transition: all 0.2s ease;
  font-family: ${key('fonts.primary', 'JetBrains Mono Regular')};
  box-sizing: border-box;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: #0066cc;
    box-shadow: 0 0 0 3px rgba(0, 102, 204, 0.1);
    background: #ffffff;
  }

  &:disabled {
    background-color: #f3f4f6;
    color: #9ca3af;
    cursor: not-allowed;
    border-color: #e5e7eb;
  }
`;

export const ToggleButton = styled.button`
  position: absolute;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  color: #6b7280;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    background-color: #f3f4f6;
    color: #374151;
  }

  &:focus-visible {
    outline: 2px solid #0066cc;
    outline-offset: 2px;
  }

  &:active:not(:disabled) {
    background-color: #e5e7eb;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }

  svg {
    width: 16px;
    height: 16px;
  }
`;

// ============================================================================
// PASSWORD MATCH INDICATOR
// ============================================================================

export const PasswordMatchText = styled.div`
  font-size: 11px;
  margin-top: 4px;
  font-weight: 500;
  color: ${(props) => (props.match === 'success' ? '#10b981' : '#dc2626')};
`;

// ============================================================================
// PASSWORD REQUIREMENTS SECTION
// ============================================================================

export const PasswordRequirementsSection = styled.div`
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 7px;
  padding: 12px 14px;
  margin-bottom: 18px;
`;

export const RequirementTitle = styled.p`
  margin: 0 0 8px 0;
  font-size: 11px;
  font-weight: 700;
  color: #374151;
  text-transform: uppercase;
  letter-spacing: 0.25px;
`;

export const RequirementList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const RequirementItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: ${(props) => (props.met ? '#10b981' : '#6b7280')};
  transition: color 0.2s ease;

  svg {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
    transition: all 0.2s ease;
  }
`;

export const ErrorText = styled.p`
  margin: 0 0 16px 0;
  font-size: 12px;
  color: #dc2626;
  line-height: 1.3;
  font-weight: 500;
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
`;

export const PrimaryButton = styled.button`
  padding: 10px 24px;
  font-size: 12px;
  font-weight: 700;
  border-radius: 7px;
  font-family: ${key('fonts.primary', 'JetBrains Mono Regular')};
  border: none;
  background: linear-gradient(90deg, #7b5cff, #60a5fa);
  color: white;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  min-width: 110px;

  &:active:not(:disabled) {
    transform: translateY(0);
  }

  &:focus-visible {
    outline: 2px solid #0066cc;
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;
